// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export const fetchTemplatesList = (employerID?: number) => {
  return { type: types.EMPLOYER_TEMPLATES_FETCH_BEGIN, employerID }
}
